module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp1_6005.90f90d5c.png";